import { Link } from '@mm/components';
import { CheckCircleIcon } from '@mm/icons';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import PricingImage from 'assets/plans/pricing.png';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { columnTwo, getColumnOne } from './featuresText';
import './PaidFeatures.pcss';

export const PaidFeatures = () => {
  const { november2021Pricing } = useSelector(combinedFeatureFlagsSelector);

  const columnOne = useMemo(
    () => getColumnOne(november2021Pricing),
    [november2021Pricing],
  );

  return (
    <div className="paid-feature--container">
      <div className="paid-feature--image-container">
        <img src={PricingImage} alt="" />
      </div>
      <div className="paid-feature--features-container">
        <div className="paid-feature--features-title">
          Generate more leads and sales
        </div>

        <div className="paid-feature--features-details">
          <div className="paid-feature--features-column-1">
            {columnOne.map((f, idx) => (
              <div className="paid-feature--features-row" key={idx}>
                <div>
                  <CheckCircleIcon color="#00cec8" size={16} />
                </div>
                <div className="paid-feature--features-row__text">{f}</div>
              </div>
            ))}
          </div>
          <div className="paid-feature--features-column-2">
            {columnTwo.map((f, idx) => (
              <div className="paid-feature--features-row" key={idx}>
                <div>
                  <CheckCircleIcon color="#00cec8" size={16} />
                </div>
                <div className="paid-feature--features-row__text">{f}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="paid-feature--features-actions">
          <div className="paid-feature--features-action-button__container">
            <PrimaryButton
              className="billing-panel__section--booking-button"
              onClick={() =>
                window.open(
                  'https://calendly.com/mobilemonkey-sales/special-consultation',
                  '_blank',
                )
              }
            >
              Book a Demo now
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
};
